module.exports = __webpack_public_path__ + "img/ic_referralprogramusd.67b3981a.svg";